import React from 'react';
import { Link } from 'react-router-dom';

const DemoButton = () => {
  return (
    <div className="demoButton">
      <span className="demoButtonText">Try Out The Demo.</span>
      <Link to="/demo"><button className="demoBtn">Demo</button></Link>
    </div>
  );
};

export default DemoButton;